<div id="page-container" role="main">
  <mat-card class="page-tile">
    <mat-card-title role="heading" aria-level="2">{{'resources.additional' | translate}}</mat-card-title>
    <mat-card-content>
      <p>{{'resources.information' | translate}}</p>
    </mat-card-content>
  </mat-card>
</div>
